/**
 * @fileoverview gRPC-Web generated client stub for acompanha.replacement_parts.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/replacement_parts/v1/replacement_parts.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.replacement_parts = {};
proto.acompanha.replacement_parts.v1 = require('./replacement_parts_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest,
 *   !proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse>}
 */
const methodDescriptor_ReplacementPartsService_ListReplacementParts = new grpc.web.MethodDescriptor(
  '/acompanha.replacement_parts.v1.ReplacementPartsService/ListReplacementParts',
  grpc.web.MethodType.UNARY,
  proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest,
  proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse,
  /**
   * @param {!proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsServiceClient.prototype.listReplacementParts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.replacement_parts.v1.ReplacementPartsService/ListReplacementParts',
      request,
      metadata || {},
      methodDescriptor_ReplacementPartsService_ListReplacementParts,
      callback);
};


/**
 * @param {!proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsServicePromiseClient.prototype.listReplacementParts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.replacement_parts.v1.ReplacementPartsService/ListReplacementParts',
      request,
      metadata || {},
      methodDescriptor_ReplacementPartsService_ListReplacementParts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.replacement_parts.v1.GetReplacementPartRequest,
 *   !proto.acompanha.replacement_parts.v1.GetReplacementPartResponse>}
 */
const methodDescriptor_ReplacementPartsService_GetReplacementPart = new grpc.web.MethodDescriptor(
  '/acompanha.replacement_parts.v1.ReplacementPartsService/GetReplacementPart',
  grpc.web.MethodType.UNARY,
  proto.acompanha.replacement_parts.v1.GetReplacementPartRequest,
  proto.acompanha.replacement_parts.v1.GetReplacementPartResponse,
  /**
   * @param {!proto.acompanha.replacement_parts.v1.GetReplacementPartRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.replacement_parts.v1.GetReplacementPartResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.replacement_parts.v1.GetReplacementPartRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.replacement_parts.v1.GetReplacementPartResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.replacement_parts.v1.GetReplacementPartResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsServiceClient.prototype.getReplacementPart =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.replacement_parts.v1.ReplacementPartsService/GetReplacementPart',
      request,
      metadata || {},
      methodDescriptor_ReplacementPartsService_GetReplacementPart,
      callback);
};


/**
 * @param {!proto.acompanha.replacement_parts.v1.GetReplacementPartRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.replacement_parts.v1.GetReplacementPartResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsServicePromiseClient.prototype.getReplacementPart =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.replacement_parts.v1.ReplacementPartsService/GetReplacementPart',
      request,
      metadata || {},
      methodDescriptor_ReplacementPartsService_GetReplacementPart);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest,
 *   !proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse>}
 */
const methodDescriptor_ReplacementPartsService_CreateReplacementPart = new grpc.web.MethodDescriptor(
  '/acompanha.replacement_parts.v1.ReplacementPartsService/CreateReplacementPart',
  grpc.web.MethodType.UNARY,
  proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest,
  proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse,
  /**
   * @param {!proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsServiceClient.prototype.createReplacementPart =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.replacement_parts.v1.ReplacementPartsService/CreateReplacementPart',
      request,
      metadata || {},
      methodDescriptor_ReplacementPartsService_CreateReplacementPart,
      callback);
};


/**
 * @param {!proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsServicePromiseClient.prototype.createReplacementPart =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.replacement_parts.v1.ReplacementPartsService/CreateReplacementPart',
      request,
      metadata || {},
      methodDescriptor_ReplacementPartsService_CreateReplacementPart);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest,
 *   !proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse>}
 */
const methodDescriptor_ReplacementPartsService_UpdateReplacementPart = new grpc.web.MethodDescriptor(
  '/acompanha.replacement_parts.v1.ReplacementPartsService/UpdateReplacementPart',
  grpc.web.MethodType.UNARY,
  proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest,
  proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse,
  /**
   * @param {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsServiceClient.prototype.updateReplacementPart =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.replacement_parts.v1.ReplacementPartsService/UpdateReplacementPart',
      request,
      metadata || {},
      methodDescriptor_ReplacementPartsService_UpdateReplacementPart,
      callback);
};


/**
 * @param {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsServicePromiseClient.prototype.updateReplacementPart =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.replacement_parts.v1.ReplacementPartsService/UpdateReplacementPart',
      request,
      metadata || {},
      methodDescriptor_ReplacementPartsService_UpdateReplacementPart);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest,
 *   !proto.acompanha.common.v1.DeleteResponse>}
 */
const methodDescriptor_ReplacementPartsService_DeleteReplacementPart = new grpc.web.MethodDescriptor(
  '/acompanha.replacement_parts.v1.ReplacementPartsService/DeleteReplacementPart',
  grpc.web.MethodType.UNARY,
  proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest,
  acompanha_common_v1_common_pb.DeleteResponse,
  /**
   * @param {!proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsServiceClient.prototype.deleteReplacementPart =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.replacement_parts.v1.ReplacementPartsService/DeleteReplacementPart',
      request,
      metadata || {},
      methodDescriptor_ReplacementPartsService_DeleteReplacementPart,
      callback);
};


/**
 * @param {!proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsServicePromiseClient.prototype.deleteReplacementPart =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.replacement_parts.v1.ReplacementPartsService/DeleteReplacementPart',
      request,
      metadata || {},
      methodDescriptor_ReplacementPartsService_DeleteReplacementPart);
};


module.exports = proto.acompanha.replacement_parts.v1;

